import { h } from "../core/dom.js";

// Feather-style stroked icons. icon(name, { size }) -> <svg>
const PATHS = {
  home: ["M3 11.5 12 4l9 7.5", "M5 10v10h14V10"],
  // Horizontal dumbbell: handle bar with a small + large plate stacked at each end.
  dumbbell: ["M8 12h8", "M8 7.5v9", "M16 7.5v9", "M5 9.5v5", "M19 9.5v5"],
  history: ["M3 12a9 9 0 1 0 3-6.7L3 8", "M3 4v4h4", "M12 8v4l3 2"],
  user: ["M4 20c0-3.3 3.6-5 8-5s8 1.7 8 5", "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  users: ["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M22 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"],
  plus: ["M12 5v14", "M5 12h14"],
  play: ["M7 4v16l13-8z"],
  heart: ["M12 20s-7-4.5-9.5-9A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9.5 5c-2.5 4.5-9.5 9-9.5 9z"],
  pulse: ["M3 12h4l2 6 4-14 2 8h6"],
  check: ["M20 6 9 17l-5-5"],
  x: ["M18 6 6 18", "M6 6l12 12"],
  timer: ["M12 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "M12 10v4l2 2", "M9 2h6"],
  edit: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"],
  trash: ["M3 6h18", "M8 6V4h8v2", "M6 6l1 14h10l1-14"],
  back: ["M15 18l-6-6 6-6"],
  forward: ["M9 6l6 6-6 6"],
  chevronDown: ["M6 9l6 6 6-6"],
  search: ["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "M21 21l-4.3-4.3"],
  flame: ["M12 3c1 3 4 4 4 8a4 4 0 0 1-8 0c0-2 1-3 1-3 .5 2 2 2 2 2 .5-3-1-5 1-7z"],
  trophy: ["M8 4h8v4a4 4 0 0 1-8 0z", "M8 6H5v2a3 3 0 0 0 3 3", "M16 6h3v2a3 3 0 0 1-3 3", "M10 13h4v3h-4z", "M9 20h6", "M12 16v4"],
  settings: ["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.3 1a7 7 0 0 0-1.7-1l-.3-2.6H10.4l-.3 2.6a7 7 0 0 0-1.7 1l-2.3-1-2 3.4L6 11a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.3-1a7 7 0 0 0 1.7 1l.3 2.6h3.2l.3-2.6a7 7 0 0 0 1.7-1l2.3 1 2-3.4-2-1.5a7 7 0 0 0 .1-1z"],
  calendar: ["M4 6h16v14H4z", "M4 9h16", "M8 3v4", "M16 3v4"],
  chart: ["M4 20V4", "M4 20h16", "M8 16v-4", "M12 16V8", "M16 16v-7"],
  list: ["M8 6h13", "M8 12h13", "M8 18h13", "M3 6h.01", "M3 12h.01", "M3 18h.01"],
  copy: ["M9 9h11v11H9z", "M5 15H4V4h11v1"],
  logout: ["M16 17l5-5-5-5", "M21 12H9", "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"],
  moon: ["M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"],
  download: ["M12 3v12", "M8 11l4 4 4-4", "M4 21h16"],
  grip: ["M9 6h.01", "M9 12h.01", "M9 18h.01", "M15 6h.01", "M15 12h.01", "M15 18h.01"],
  info: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M12 11v5", "M12 8h.01"],
  weight: ["M7 8h10l2 12H5z", "M9 8a3 3 0 1 1 6 0"],
  camera: ["M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z", "M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  flip: ["M3 7h13a4 4 0 0 1 4 4v1", "M16 4l-3 3 3 3", "M21 17H8a4 4 0 0 1-4-4v-1", "M8 20l3-3-3-3"],
  shield: ["M12 3l8 3v6c0 4.5-3 7.5-8 9-5-1.5-8-4.5-8-9V6z"],
  lock: ["M5 11h14v9H5z", "M8 11V8a4 4 0 0 1 8 0v3"],
  link: ["M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1", "M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"],
  flag: ["M4 21V4", "M4 4h13l-2 4 2 4H4"],
  ruler: ["M3 8h18v8H3z", "M7 8v3", "M11 8v4", "M15 8v3", "M19 8v4"],
  target: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z", "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"],
  // Bow + arrow aimed at the top-right corner (matches the app icon): stave bulges toward
  // the arrowhead, string is the lower-left chord, fletching at the lower-left nock.
  bow: ["M6.4 7.7 C12.4 6.6 17.4 11.6 16.3 17.6", "M6.4 7.7 16.3 17.6", "M8.5 15.5 17 7", "M12.7 7 17 7 17 11.3", "M8.5 15.5 5.6 15.5", "M8.5 15.5 8.5 18.4"],
};

// Achievement badges carry an icon KEY from the server; unknown keys (e.g. a stale cached
// payload still holding emoji) fall back to rendering the raw string.
export function achIcon(key, { size = 28 } = {}) {
  return PATHS[key] ? icon(key, { size }) : h("span", null, String(key));
}

export function icon(name, { size = 22, fill = false, stroke = 2, className = "icon" } = {}) {
  const paths = PATHS[name] || [];
  return h(
    "svg",
    {
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      fill: fill ? "currentColor" : "none",
      stroke: fill ? "none" : "currentColor",
      "stroke-width": stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: className,
      "aria-hidden": "true",
    },
    ...paths.map((d) => h("path", { d }))
  );
}
